import React from 'react';

import {
  Dialog,
  DialogButtonType,
  DialogProps,
} from '@ast/magma/components/dialog';

import { useIsMobile } from '@app/common/utils/hooks/useIsMobile';

export type ConfirmModalProps = Omit<
DialogProps,
'buttons'
| 'defaultButton'
| 'form'
| 'status'
| 'focusDefaultButton'
> & {
  readonly cancelLabel: string
  readonly okLabel: string
  readonly confirmStableName?: string
  readonly cancelStableName?: string
};

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  cancelLabel,
  children,
  okLabel,
  ...props
}) => {
  const isMobile = useIsMobile();

  const buttons = React.useMemo(
    () => {
      let btns = [
        {
          label: okLabel,
          type: DialogButtonType.OK,
          // we return false, to make popup close after click
          onClick: () => false,
          ...(props.confirmStableName ? { ['data-stable-name']: props.confirmStableName } : {}),
        },
      ];
      if (!isMobile) {
        // according to design, we hide cancel button for mobile
        btns = [
          {
            label: cancelLabel,
            type: DialogButtonType.Cancel,
            // we return false, to make popup close after click
            onClick: () => false,
            ...(props.cancelStableName ? { ['data-stable-name']: props.cancelStableName } : {}),
          },
          ...btns,
        ];
      }
      return btns;
    },
    [isMobile],
  );

  return (
    <Dialog
      {...props}
      buttons={buttons}
      defaultButton={DialogButtonType.OK}
    >
      <div>
        {children}
      </div>
    </Dialog>
  );
};
